/* Buddha Trace — welcome-gift pop-up. Markup: sections/bt-gift-popup.liquid
 *
 * Steps: 1 teaser → 2 email (Shopify customer form) → 3 codes.
 * Shopify reloads the page after the form posts; a sessionStorage flag set on
 * submit tells us the reload is ours, and the section reports success/errors.
 * Any link to "#gift" (or element with data-btg-open) opens it again.
 */
(() => {
  const KEY = 'btg:v1';    // localStorage { until: ms, done: true }
  const SENT = 'btg:sent'; // sessionStorage, survives Shopify's post-submit redirect
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;

  const store = {
    get() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
    set(patch) { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(store.get(), patch))); } catch (e) {} },
  };
  const sent = {
    get() { try { return sessionStorage.getItem(SENT) === '1'; } catch (e) { return false; } },
    set(on) { try { on ? sessionStorage.setItem(SENT, '1') : sessionStorage.removeItem(SENT); } catch (e) {} },
  };

  let api = null;

  function init(root) {
    if (!root || root.dataset.ready) return;
    if (api) api.destroy();
    root.dataset.ready = '1';

    const $ = (s, el = root) => el.querySelector(s);
    const $$ = (s, el = root) => Array.from(el.querySelectorAll(s));
    const cfg = root.dataset;
    const demo = cfg.demo === 'true';
    const design = cfg.design === 'true';
    const modal = $('.btg__modal');
    const form = $('form');
    const email = form && $('input[type="email"]', form);
    const submit = form && $('[type="submit"]', form);
    const errorEl = $('.btg__error');
    const img = $('.btg__img');
    const timers = [];
    const offs = [];
    let isOpen = false;
    let lastFocus = null;
    let swapTimer = 0;

    const on = (target, type, fn, opts) => {
      target.addEventListener(type, fn, opts);
      offs.push(() => target.removeEventListener(type, fn, opts));
    };
    const later = (fn, ms) => timers.push(setTimeout(fn, ms));
    const panel = (n) => $(`[data-step-panel="${n}"]`);

    function fit() {
      $$('[data-fit]').forEach((el) => {
        if (!el.getClientRects().length) return;
        el.style.fontSize = '';
        const room = el.parentElement.clientWidth;
        const width = el.offsetWidth;
        if (width > room) {
          el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * room / width * 0.97).toFixed(1) + 'px';
        }
      });
    }

    function setStep(n, animate) {
      n = String(n);
      const next = panel(n);
      if (!next) return;
      const cur = $('[data-step-panel]:not([hidden])');
      clearTimeout(swapTimer);
      const swap = () => {
        $$('[data-step-panel]').forEach((p) => {
          p.hidden = p !== next;
          p.classList.remove('is-leaving');
        });
        root.dataset.step = n;
        const heading = $('[data-btg-heading]', next);
        if (heading) modal.setAttribute('aria-labelledby', heading.id);
        fit();
        if (isOpen) focusStep(n);
      };
      if (animate && cur && cur !== next && !reduced) {
        cur.classList.add('is-leaving');
        swapTimer = setTimeout(swap, 300);
      } else {
        swap();
      }
    }

    function focusStep(n) {
      const target = n === '2' ? email : modal;
      setTimeout(() => target && target.focus({ preventScroll: true }), reduced ? 0 : 420);
    }

    function open(step) {
      step = String(step || 1);
      if (isOpen) { setStep(step, true); return; }
      isOpen = true;
      lastFocus = document.activeElement;
      if (img) img.loading = 'eager';
      root.hidden = false;
      setStep(step);
      document.documentElement.classList.add('btg-lock');
      void root.offsetWidth; // commit the closed styles so the open transition runs
      root.classList.add('is-open');
      fit();
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('btg-lock');
      if (!demo && !design) {
        if (root.dataset.step === '3') store.set({ done: true });
        else store.set({ until: Date.now() + (parseFloat(cfg.days) || 7) * 864e5 });
      }
      later(() => { if (!isOpen) root.hidden = true; }, reduced ? 0 : 650);
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    }

    function showError(msg) {
      if (errorEl) errorEl.textContent = msg || '';
      if (email) email.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }

    function sending(busy) {
      if (!submit) return;
      if (!submit.dataset.label) submit.dataset.label = submit.textContent.trim();
      submit.textContent = busy ? (cfg.sending || 'Unsealing…') : submit.dataset.label;
      root.classList.toggle('is-sending', busy);
    }

    async function copy(btn) {
      const code = btn.dataset.btgCopy;
      if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
      try {
        await navigator.clipboard.writeText(code);
      } catch (e) {
        const range = document.createRange();
        range.selectNodeContents(btn.parentElement.querySelector('code'));
        const sel = getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        try { document.execCommand('copy'); } catch (err) {}
      }
      btn.textContent = cfg.copied || 'Copied';
      btn.classList.add('is-copied');
      setTimeout(() => {
        btn.textContent = btn.dataset.label;
        btn.classList.remove('is-copied');
      }, 1800);
    }

    function eligible() {
      if (/[?&]bt_gift=1\b/.test(location.search)) return true;
      if (cfg.subscribed === 'true') return false;
      const s = store.get();
      return !s.done && !(s.until > Date.now());
    }

    function arm() {
      let armed = true;
      const fire = () => {
        if (!armed || isOpen) return;
        armed = false;
        open(1);
      };
      const delay = Math.max(0, parseFloat(cfg.delay) || 0) * 1000;
      if (delay > 0) {
        later(() => { if (img) img.loading = 'eager'; }, Math.max(0, delay - 3000));
        later(fire, delay);
      }
      if (cfg.exit === 'true' && finePointer) {
        const since = Date.now();
        on(document, 'mouseout', (e) => {
          if (!e.relatedTarget && e.clientY <= 0 && Date.now() - since > 4000) fire();
        });
      }
      const pct = parseFloat(cfg.scroll) || 0;
      if (pct > 0) {
        on(window, 'scroll', () => {
          const max = document.documentElement.scrollHeight - innerHeight;
          if (max > 0 && (scrollY / max) * 100 >= pct) fire();
        }, { passive: true });
      }
    }

    /* motes of gold dust drifting up through the candlelight */
    const motes = $('.btg__motes');
    if (motes && !reduced && !motes.children.length) {
      for (let i = 0; i < 18; i++) {
        const m = document.createElement('i');
        const r = Math.random;
        m.style.cssText = `--x:${38 + r() * 58}%;--y:${50 + r() * 50}%;--s:${(1 + r() * 2.2).toFixed(1)}px;` +
          `--d:${(9 + r() * 9).toFixed(1)}s;--t:${(-r() * 18).toFixed(1)}s;--dx:${((r() - 0.5) * 90).toFixed(0)}px`;
        motes.appendChild(m);
      }
    }

    on(root, 'click', (e) => {
      const t = e.target.closest('[data-btg-close],[data-btg-next],[data-btg-copy]');
      if (!t) return;
      if (t.hasAttribute('data-btg-next')) setStep(2, true);
      else if (t.hasAttribute('data-btg-copy')) copy(t);
      else close();
    });

    on(document, 'keydown', (e) => {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      const items = $$('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled])')
        .filter((el) => el.getClientRects().length);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;
      if (!root.contains(active)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (active === first || active === modal)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    });

    if (finePointer && !reduced) {
      on(modal, 'pointermove', (e) => {
        const r = modal.getBoundingClientRect();
        modal.style.setProperty('--lx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        modal.style.setProperty('--ly', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
      });
    }

    if (form) {
      on(form, 'submit', (e) => {
        showError('');
        if (!email.value.trim() || !email.checkValidity()) {
          e.preventDefault();
          showError(cfg.invalid || 'Please enter a valid email address.');
          email.focus();
          return;
        }
        if (demo || design) { // never create customers from the preview or the theme editor
          e.preventDefault();
          sending(true);
          setTimeout(() => { sending(false); setStep(3, true); }, 900);
          return;
        }
        sent.set(true);
        sending(true);
      });
      on(email, 'input', () => showError(''));
    }

    on(window, 'resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    /* the page we land on after Shopify posts the form */
    const state = $('[data-btg-state]');
    const posted = state && state.dataset.posted === 'true';
    const error = state && state.dataset.error;
    const ours = sent.get() || (form && location.hash === '#' + form.id);
    if (ours && (posted || error)) {
      sent.set(false);
      if (posted) {
        store.set({ done: true });
        open(3);
      } else {
        open(2);
        showError(error);
      }
    } else if (!design && (demo || eligible())) {
      arm();
    }

    return {
      open,
      close,
      fit,
      done: () => !!store.get().done,
      editorStep: cfg.editorStep || '1',
      destroy() {
        timers.forEach(clearTimeout);
        clearTimeout(swapTimer);
        offs.forEach((off) => off());
        document.documentElement.classList.remove('btg-lock');
      },
    };
  }

  const boot = (root) => { api = init(root) || api; };
  const ownSection = (e) => e.target && e.target.querySelector && e.target.querySelector('[data-btg]');

  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-btg-open],a[href="#gift"]');
    if (!t || !api) return;
    e.preventDefault();
    api.open(api.done() ? 3 : 1);
  });

  /* Shopify theme editor */
  document.addEventListener('shopify:section:load', (e) => {
    const root = ownSection(e);
    if (root) { boot(root); api.open(api.editorStep); }
  });
  document.addEventListener('shopify:section:unload', (e) => { if (ownSection(e) && api) { api.destroy(); api = null; } });
  document.addEventListener('shopify:section:select', (e) => { if (ownSection(e) && api) api.open(api.editorStep); });
  document.addEventListener('shopify:section:deselect', (e) => { if (ownSection(e) && api) api.close(); });

  window.BtGift = {
    open: (step) => api && api.open(step),
    close: () => api && api.close(),
    fit: () => api && api.fit(),
  };

  const first = document.querySelector('[data-btg]');
  if (first) boot(first);
  else document.addEventListener('DOMContentLoaded', () => boot(document.querySelector('[data-btg]')));
})();
